( function( $ ) {
	$( function() {
		wp._lin_vimeo_players = wp._lin_vimeo_players || [];

		const siteMain = document.getElementById( 'main' );
		const sections = siteMain.getElementsByClassName( 'section' );

		// Helper: Checks given element is completely visible in viewport
		function isElementInViewport( el ) {
			if ( null === el ) {
				return false;
			}

			const rect = el.getBoundingClientRect();
			const top = rect.top;
			const bottom = rect.bottom;
			const animationTriggerHeight = window.innerHeight * 0.75;

			/**
			 * Potentially confusing logic ahead...
			 * *
			 * Condition: `bottom >= 0`
			 * Is the bottom of the element below the top of the window?
			 *
			 * Condition: `top <= animationTriggerHeight`
			 * Is the top of the element above the animation trigger height?
			 * i.e. is enough of the element visible in the screen viewport to
			 * start the animation?
			 */
			return bottom >= 0 && top <= animationTriggerHeight;
		}

		// Helper: Runs the animation the first time the element becomes visible
		function onVisibilityChange( el, callback ) {
			let old_visible = false;

			return function() {
				const visible = isElementInViewport( el );
				if ( visible && visible !== old_visible ) {
					if ( typeof callback === 'function' ) {
						callback( el );
					}
				}
				if ( ! visible && visible !== old_visible ) {
					vimeoID = el.dataset.linVimeo;
					if ( vimeoID ) {
						wp._lin_vimeo_players[ vimeoID ].pause();
					}
				}

				old_visible = visible;
			};
		}

		// Helper: Adds a class to an element so the animation runs
		function makeVisible( el ) {
			if ( ! el.classList.contains( 'is-visible' ) ) {
				el.classList.add( 'is-visible' );
			}
			vimeoID = el.dataset.linVimeo;
			if ( vimeoID ) {
				wp._lin_vimeo_players[ vimeoID ].play();
			}
		}

		for ( let i = 0, secLen = sections.length; i < secLen; i++ ) {
			const animation_handler = onVisibilityChange(
				sections[ i ],
				makeVisible
			);

			// Add event listeners to fire the animation handler function
			window.addEventListener( 'DOMContentLoaded', animation_handler, false );
			window.addEventListener( 'load', animation_handler, false );
			window.addEventListener( 'scroll', animation_handler, false );
			window.addEventListener( 'resize', animation_handler, false );
		}
	} );
}( jQuery ) );
